import React from 'react';

function Services() {
  return (
    <section className="portfolio-tab crev section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">What We Do</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600 text-u ls1">
              Our <span className="fw-200">Initiatives</span>
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-5 d-flex align-items-center justify-content-center">
            <div className="glry-img">
              <div id="tab-1" className="bg-img tab-img current" data-background="/light/assets/imgs/spob/initiative-1.jpg"></div>
              <div id="tab-2" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-2.jpg"></div>
              <div id="tab-3" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-3.jpg"></div>
              <div id="tab-4" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-4.jpg"></div>
              <div id="tab-5" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-5.jpg"></div>
              <div id="tab-6" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-6.jpg"></div>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1 content">
            <div className="cluom mb-30 current" data-tab="tab-1">
              <div className="info">
                <h6 className="sub-title opacity-7">Health</h6>
                <h4>Health Awareness &amp; Community Outreach</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-1.jpg" alt="Health Awareness" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-health">
                  Get Involved <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom mb-30" data-tab="tab-2">
              <div className="info">
                <h6 className="sub-title opacity-7">Education</h6>
                <h4>Nigeria School Uniform Equity Initiative (NSUEI)</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-2.jpg" alt="School Uniform Equity" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-nsuei">
                  Get Involved <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom mb-30" data-tab="tab-3">
              <div className="info">
                <h6 className="sub-title opacity-7">Education</h6>
                <h4>Foundational Learning &amp; Academic Support (FLASI)</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-3.jpg" alt="Foundational Learning" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-flasi">
                  Get Involved <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom mb-30" data-tab="tab-4">
              <div className="info">
                <h6 className="sub-title opacity-7">Culture</h6>
                <h4>Yoruba Heritage &amp; Language Cultural Literacy</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-4.jpg" alt="Yoruba Heritage" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-yoruba">
                  Get Involved <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom mb-30" data-tab="tab-5">
              <div className="info">
                <h6 className="sub-title opacity-7">Environment</h6>
                <h4>Eco-Awareness &amp; Environmental Sustainability</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-5.jpg" alt="Eco Awareness" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-eco">
                  Get Involved <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom" data-tab="tab-6">
              <div className="info">
                <h6 className="sub-title opacity-7">Economic Empowerment</h6>
                <h4>Vocational Skills &amp; Economic Empowerment</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-6.jpg" alt="Vocational Skills" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-vocational">
                  Get Involved <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
